import { z } from 'zod';
import { DepartmentSchema, RoleGradeSchema } from './headcount';
/**
 * Position exception (headcount planning A6, planning doc 3.5).
 *
 * A position that fails the envelope check at planned -> approved can still be
 * approved through an exception: an owned, time-boxed, on-the-record claim.
 * Exceptions are created only by the transitionHiringPosition callable (the
 * gate is the sole minting path) and attach to the position permanently via
 * exception_id.
 *
 * Cadence (D18, 2026-07-13): the gate is continuous — there is no quarterly
 * re-planning window. Each exception carries its own review_date; an open
 * exception past its review date reads as 'due' (derived by
 * classifyExceptionStatus, never stored) and must be extended or resolved at
 * the monthly leadership review.
 */
export const POSITION_EXCEPTION_STATUSES = ['open', 'resolved', 'cancelled'];
export const PositionExceptionStatusSchema = z.enum(POSITION_EXCEPTION_STATUSES);
export const ExceptionCheckMonthSchema = z.object({
    month: z.string().regex(/^\d{4}-(0[1-9]|1[0-2])$/),
    target_dollars: z.number(),
    projected_dollars: z.number(),
});
const DATE_PATTERN = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
export const HiringPositionExceptionSchema = z.object({
    id: z.string().min(1),
    position_id: z.string().min(1),
    department: DepartmentSchema,
    role_grade: RoleGradeSchema,
    target_start_month: z.string().regex(/^\d{4}-\d{2}-01$/),
    owner_id: z.string().min(1),
    owner_name: z.string().min(1),
    rationale: z.string().min(1).max(1000),
    expected_return: z.string().min(1).max(1000),
    review_date: z.string().regex(DATE_PATTERN),
    status: PositionExceptionStatusSchema,
    resolution_note: z.string().max(1000).nullable(),
    envelope_derivation_month: z.string().nullable(),
    failing_months: z.array(ExceptionCheckMonthSchema),
    created_at: z.string().min(1),
    created_by: z.string().min(1),
    created_by_name: z.string().min(1),
    updated_at: z.string().min(1),
    updated_by: z.string().min(1),
});
export const PositionExceptionPitchSchema = z.object({
    rationale: z.string().min(1).max(1000),
    expected_return: z.string().min(1).max(1000),
    review_date: z.string().regex(DATE_PATTERN),
});
